import { track } from "@amplitude/analytics-react-native";
import { useCallback, useRef, useState } from "react";
import { amp } from "src/api/amplitude";
import RoundedButton, { RoundedButtonProps } from "src/components/RoundedButton";
import IconAddPhoto from "src/icons/IconAddPhoto";
import UploadPhotosPrompt from "./UploadPhotosPrompt";
import { UploadPhotosPromptHandler } from "./UploadPhotosPrompt/types";

const GatheringUploadPhotosButton = ({
	isAvailable = true,
	sizeVariant,
}: {
	isAvailable?: boolean;
	sizeVariant?: RoundedButtonProps["sizeVariant"];
}) => {
	const uploadPhotosPromptRef = useRef<UploadPhotosPromptHandler>(null);
	const [loading, setLoading] = useState(false);
	const handlePress = useCallback(async () => {
		try {
			setLoading(true);
			track(amp.gathering.uploadPhotosButtonPressed);
			await uploadPhotosPromptRef.current?.promptUploadPhotos();
		} finally {
			setLoading(false);
		}
	}, []);

	return (
		<>
			<RoundedButton
				testID={isAvailable ? "UploadPhotosButton" : undefined}
				Icon={IconAddPhoto}
				loading={loading}
				onPress={handlePress}
				sizeVariant={sizeVariant}
			>
				{sizeVariant !== "CircleLarge" ? "Add pics" : undefined}
			</RoundedButton>
			<UploadPhotosPrompt ref={uploadPhotosPromptRef} />
		</>
	);
};
export default GatheringUploadPhotosButton;
